(function () {
  var config = window.psMotion || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarsePointer = window.matchMedia('(pointer: coarse)').matches;

  function showAll(selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.add('is-visible');
      el.style.transitionDelay = '';
    });
  }

  if (reduceMotion) {
    showAll('.ps-reveal');
    showAll('.ps-reveal-item');
    document.querySelectorAll('.ps-has-watermark').forEach(function (el) {
      el.classList.add('is-wm-visible');
      el.style.setProperty('--ps-wm-y', '0px');
    });
    return;
  }

  /* Section-level reveal */
  if (config.reveal !== false) {
    var reveals = document.querySelectorAll('.ps-reveal');
    if (reveals.length && 'IntersectionObserver' in window) {
      var sectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              sectionObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      reveals.forEach(function (el) {
        sectionObserver.observe(el);
      });
    } else {
      showAll('.ps-reveal');
    }
  } else {
    showAll('.ps-reveal');
  }

  /* Staggered item reveal (cards) */
  if (config.reveal !== false) {
    var items = document.querySelectorAll('.ps-reveal-item');
    if (items.length && 'IntersectionObserver' in window) {
      var itemObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var siblings = el.parentElement
              ? el.parentElement.querySelectorAll(':scope > .ps-reveal-item')
              : [];
            var index = 0;
            siblings.forEach(function (sib, i) {
              if (sib === el) index = i;
            });
            el.style.transitionDelay = index * 90 + 'ms';
            el.classList.add('is-visible');
            itemObserver.unobserve(el);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.12 }
      );
      items.forEach(function (el) {
        itemObserver.observe(el);
      });
    } else {
      showAll('.ps-reveal-item');
    }
  } else {
    showAll('.ps-reveal-item');
  }

  /* Watermark: fade-in on enter + light scroll parallax */
  var watermarks = document.querySelectorAll('.ps-has-watermark');
  if (watermarks.length) {
    if ('IntersectionObserver' in window) {
      var wmObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-wm-visible');
              wmObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
      );
      watermarks.forEach(function (el) {
        wmObserver.observe(el);
      });
    } else {
      watermarks.forEach(function (el) {
        el.classList.add('is-wm-visible');
      });
    }

    if (config.parallax !== false) {
      var wmList = Array.prototype.slice.call(watermarks);
      var wmTicking = false;
      var wmMax = 36;

      function updateWatermarkParallax() {
        wmTicking = false;
        var vh = window.innerHeight || 1;
        wmList.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.bottom < -80 || rect.top > vh + 80) return;
          var progress = (rect.top + rect.height * 0.5 - vh * 0.5) / vh;
          var offset = Math.max(-wmMax, Math.min(wmMax, progress * -wmMax));
          el.style.setProperty('--ps-wm-y', offset.toFixed(1) + 'px');
        });
      }

      function onWmScroll() {
        if (wmTicking) return;
        wmTicking = true;
        window.requestAnimationFrame(updateWatermarkParallax);
      }

      window.addEventListener('scroll', onWmScroll, { passive: true });
      window.addEventListener('resize', onWmScroll, { passive: true });
      updateWatermarkParallax();
    }
  }

  /* Hero cursor parallax */
  if (config.parallax === false || coarsePointer) return;

  document.querySelectorAll('.ps-hero__media').forEach(function (media) {
    var img = media.querySelector('.ps-hero__img');
    if (!img) return;

    media.addEventListener('mousemove', function (e) {
      var rect = media.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      img.style.transform =
        'scale(1.04) translate(' + x * -14 + 'px, ' + y * -10 + 'px)';
    });

    media.addEventListener('mouseleave', function () {
      img.style.transform = '';
    });
  });
})();
